import gql from 'graphql-tag';

export const CREATE_PROPERTY_MUTATION = gql`
  mutation createProperty($propertyInputDetails: PropertyInput!) {
    createProperty(propertyInput: $propertyInputDetails) {
      id
      testatorId
      physicalAddress
      ownership
      percentageShare
      displayName
      marketValue
      outstandingDebt
      specificDonation {
        id
      }
    }
  }
`;

export const UPDATE_PROPERTY_MUTATION = gql`
  mutation updateProperty($id: ID!, $propertyInputDetails: PropertyInput!) {
    updateProperty(id: $id, propertyInput: $propertyInputDetails) {
      id
      testatorId
      physicalAddress
      ownership
      percentageShare
      displayName
      marketValue
      outstandingDebt
      specificDonation {
        id
      }
    }
  }
`;

export const DELETE_PROPERTY_MUTATION = gql`
  mutation deleteProperty($id: ID!) {
    deleteProperty(id: $id) {
      id
    }
  }
`;
